/**
 * Event Bus Composable
 * 컴포넌트 간 이벤트 통신을 위한 유틸리티
 */
import { onUnmounted } from 'vue';
class EventBus {
    constructor() {
        Object.defineProperty(this, "events", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    /**
     * 이벤트 발생
     */
    emit(event, data) {
        const callbacks = this.events.get(event);
        if (callbacks) {
            callbacks.forEach((callback) => {
                try {
                    callback(data);
                }
                catch (error) {
                    console.error(`[EventBus] 이벤트 ${event} 처리 중 오류:`, error);
                }
            });
        }
    }
    /**
     * 이벤트 구독
     */
    on(event, callback) {
        if (!this.events.has(event)) {
            this.events.set(event, new Set());
        }
        this.events.get(event).add(callback);
        // 구독 해제 함수 반환
        return () => {
            this.off(event, callback);
        };
    }
    /**
     * 이벤트 구독 해제
     */
    off(event, callback) {
        const callbacks = this.events.get(event);
        if (callbacks) {
            callbacks.delete(callback);
            if (callbacks.size === 0) {
                this.events.delete(event);
            }
        }
    }
    /**
     * 특정 이벤트의 모든 구독 해제
     */
    offAll(event) {
        this.events.delete(event);
    }
    /**
     * 모든 이벤트 구독 해제
     */
    clear() {
        this.events.clear();
    }
    /**
     * 이벤트 구독자 수 확인
     */
    getListenerCount(event) {
        return this.events.get(event)?.size || 0;
    }
    /**
     * 모든 이벤트 목록 확인
     */
    getEvents() {
        return Array.from(this.events.keys());
    }
}
// 전역 EventBus 인스턴스
const globalEventBus = new EventBus();
/**
 * Event Bus Composable
 */
export function useEventBus() {
    const subscriptions = [];
    /**
     * 이벤트 구독 (자동 정리)
     */
    const on = (event, callback) => {
        const unsubscribe = globalEventBus.on(event, callback);
        subscriptions.push(unsubscribe);
    };
    /**
     * 이벤트 발생
     */
    const emit = (event, data) => {
        globalEventBus.emit(event, data);
    };
    /**
     * 컴포넌트 언마운트 시 자동으로 모든 구독 해제
     */
    onUnmounted(() => {
        subscriptions.forEach((unsubscribe) => unsubscribe());
        subscriptions.length = 0;
    });
    return {
        on,
        emit,
    };
}
/**
 * 전역 EventBus 인스턴스 직접 접근 (필요시)
 */
export { globalEventBus };
/**
 * 이벤트 타입 정의
 * @remarks TradingView streaming 차트용 실시간 시세 브리지
 */
export const MARKET_EVENTS = {
    DATA_UPDATED: 'market:data-updated',
};
//# sourceMappingURL=useEventBus.js.map